$(document).ready(function () {

    $('.static-feat-item').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: true,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1199,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 1440,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
        }
        },
         {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1.4,
            slidesToScroll: 1,
        }
        }
    ]
    });


    $('.custom-icon-with-text-item').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: true,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        }
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1.4,
            slidesToScroll: 1,
        }
        }
    ]
    });

    var $window = $(window);
    function check_if_in_view() {
        $(".num > span").each(function () {
            if ($(this).hasClass("start")) {
                var elementTop = $(this).offset().top,
                    elementBottom = elementTop + $(this).outerHeight(),
                    viewportTop = $(window).scrollTop(),
                    viewportBottom = viewportTop + $(window).height();
                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    $(this).removeClass("start"), $(".num > span").text();
                    var myNumbers = $(this).text();
                    myNumbers == Math.floor(myNumbers) &&
                        $(this).animate(
                            { Counter: $(this).text() },
                            {
                                duration: 2800,
                                easing: "swing",
                                step: function (now) {
                                    $(this).text(Math.ceil(now) + "");
                                },
                            }
                        );
                }
            }
        });
    }
    $window.on("scroll", check_if_in_view), $window.on("load", check_if_in_view);




});

